import { html } from "../../.."
import { FocusSet } from "../../../global/globalapi"
import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export class SYSDateTime extends SYSControlBase {
  // change is important for eg. autofilled form inputs
  handleChange(e: Event) {
    this.field._state.valueChangedHandled = true
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: this.inputElement.value,
      isInnerEvent: false,
      watched: true,
      noRetrigger: true,
    })
  }
  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }

    let field = this.field
    let readonly = this.getReadOnly()
    return html`
      <div
        class="${this.getContainerClass(
          "textbox",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <input
          tabindex="${readonly ? "-1" : "0"}"
          @focusout=${(e) => {
            if (!field._state.valueChangedHandled) {
              this.actions.ovl.form._ChangeField({
                fieldKey: this.field.fieldKey,
                formState: this.formState,
                value: this.inputElement.value,
                isInnerEvent: false,
                watched: true,
                noRetrigger: true,
              })
            }

            _focusOutHelper(e, this.field)
          }}
          @focus=${() => {
            _setFieldFocus(this.field, true)
          }}
          @change=${(e) => this.handleChange(e)}
          @click=${(e) => FocusSet(field.id)}
          ?readonly=${readonly}
          class=${`ovl-formcontrol-value fd-input  __inpfocbox ${this.getInputClass(
            "textbox",
            this.customInfo.customRowClassName
          )}`}
          type="datetime-local"
          id=${field.id}
          value=${field.value}
        />
        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    // don't set if focus (in editing) because safari has troubles with it (cursor jumping)
    if (this.inputElement) {
      this.inputElement.value = this.field.value
    }
    await super.afterRender()
  }
  async disconnectedCallback() {
    this.inputElement = null
    await super.disconnectedCallback()
  }
}
